const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export default (klaviyoListId, klaviyoCompanyId) => ({
  isAttempted: false,
  isSubmitting: false,
  email: '',
  error: null,
  networkError: false,
  isSubscribed: false,
  klaviyoListId,
  klaviyoCompanyId,

  get isValid() {
    if (this.email.length === 0) {
      this.error = 'Email is required';
      return false;
    } else if (emailRegex.test(this.email) === false) {
      this.error = 'Please enter a valid email address';
      return false;
    } else {
      if (this.networkError === false) {
        this.error = null;
      }
      return true;
    }
  },

  get shouldReportError() {
    return this.isAttempted && this.error !== null;
  },

  async handleSubmit(e) {
    e.preventDefault();
    this.isAttempted = true;

    if (this.isValid) {
      this.networkError = false;
      this.isSubmitting = true;

      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoCompanyId}`;
      const options = {
        method: 'POST',
        headers: { revision: '2023-07-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.email,
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: `${this.klaviyoListId}` } },
            },
          },
        }),
      };

      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          throw new Error();
        }
        if (response.ok) {
          this.isSubscribed = true;
        }
      } catch {
        this.error = 'Something went wrong, please try again later.';
        this.networkError = true;
      } finally {
        setTimeout(() => (this.networkError = false), 5000);
      }

      this.isSubmitting = false;
    }
  },
});
